import {useEffect } from 'react'
import { Link, useNavigate } from "react-router-dom"
import { useTripsContext } from '../hooks/useTripsContext'
import { useAuthContext } from '../hooks/useAuthContext'
import Loader from './Loader'

//components
import TripDetails from '../components/TripDetails'
//import WorkoutForm from '../components/WorkoutForm'

const Home = () => {
    const { trips, dispatch} = useTripsContext()
    const {user} = useAuthContext()
    const navigate = useNavigate()

    useEffect(() => {  //code that runs after render //useEffects are side effects that happens when something renders/something changes
        if (!user) {
            navigate('/')
            return
        }
        const fetchTrips = async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trip`, {
                credentials: 'include'
            }) //fetch data and stores response ins response object
            const json = await response.json() //passes the response to json (makes it an array of workout objects)       
            if (response.ok) {
                dispatch({type: 'SET_TRIPS', payload: json})
            }
        }
        fetchTrips()
    }, [dispatch, user, navigate])  //with an empty array it only fires once when the component renders, things like [count] re-runs each time count state changes

    if (!user) {
        return <Loader />
    }

    return (
        <div className="home">
            <Link to="/new_trip">
                <button className="create-trip-btn">Create New Trip</button>
            </Link>
            <div className="trips">
                {trips && trips.map((trip) => (
                    <TripDetails key={trip._id} trip={trip}/>
                ))}
            </div>
        </div>
    )
}

export default Home